import { render, staticRenderFns } from "./ButtonsDialogData.vue?vue&type=template&id=c8ba7206&scoped=true&"
import script from "./ButtonsDialogData.vue?vue&type=script&lang=js&"
export * from "./ButtonsDialogData.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsDialogData.vue?vue&type=style&index=0&id=c8ba7206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ba7206",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VMenu,VSpacer})
